import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _createProject = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/projects`,
    payload,
    config
  )
}

const _getProjects = params => { 
  const token = getUserToken()
  const config = {
    timeout: 15000,
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/projects?${params.q}&populate[0][path]=company` : `${window.config.VUE_APP_BACKEND}/api/projects?limit=50&populate[0][path]=company`
  return Request.get(url, config);
};

const _deleteProject = projectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/projects/${projectId}`, config)
}

const _getProject = projectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/projects/${projectId}`, config)
}
const _updateProject = (project) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/projects/${project._id}`, project, config)
}

const _updateGlobalVars = (projectId, globalVars) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/projects/${projectId}/global-vars`, { globalVars }, config)
}

const _archiveProject = projectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/projects/${projectId}/archive`, {}, config)
}

const _unarchiveProject = projectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/projects/${projectId}/unarchive`, {}, config)
}

const _getItems = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items`


  return Request.get(
    url,
    config
  )
}

const _getItemsV2 = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items/v2?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/v2`


  return Request.get(
    url,
    config
  )
}

const _updateItem = (item) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/items/${item._id}`, item, config)
}

const _getCustomers = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/customers/v2?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/customers/v2`


  return Request.get(
    url,
    config
  )
}

const _getDiscoverToken = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= `${window.config.VUE_APP_BACKEND}/api/projects/discover-token?${params.q}`

  return Request.get(
    url,
    config
  )
}

const _getImageConcept = payload=> {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/projects/image-concept`,
    payload,
    config
  )
}

const _getEmbeddings = payload=> {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/projects/embeddings`,
    payload,
    config
  )
}

const _getSearchRedirects = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= `${window.config.VUE_APP_BACKEND}/api/searches/redirect?${params.q}`

  return Request.get(
    url,
    config
  )
}

const _updateRedirect = (redirect) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/searches/redirect/${redirect._id}`, redirect, config)
}

const _deleteRedirect = redirectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/searches/redirect/${redirectId}`, config)
}

const _createRedirect = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/searches/redirect`,
    payload,
    config
  )
}

const _getApplication = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/applications?${params.q}`, config)
}

// Curated info about the project's predictive models (quality, drivers,
// bucket definitions) for the audience builder's explainer panel.
const _getSegmentationInfo = projectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/projects/${projectId}/segmentation-info`, config)
}


export default {
  updateProject: _updateProject,
  updateGlobalVars: _updateGlobalVars,
  deleteProject : _deleteProject,
  archiveProject : _archiveProject,
  unarchiveProject : _unarchiveProject,
  getProject : _getProject,
  getSegmentationInfo : _getSegmentationInfo,
  getProjects : _getProjects,
  createProject : _createProject,
  getItems: _getItems,
  getItemsV2: _getItemsV2,
  updateItem:_updateItem,
  getCustomers : _getCustomers,
  getDiscoverToken: _getDiscoverToken,
  getEmbeddings : _getEmbeddings,
  getImageConcept : _getImageConcept,
  getSearchRedirects: _getSearchRedirects,
  deleteRedirect: _deleteRedirect,
  updateRedirect: _updateRedirect,
  createRedirect: _createRedirect,
  getApplication: _getApplication
}
